import userAPI from '../../../api/user'
import moment from 'moment'

const state = {
  allData: [],
  contributions: [],
  chartContributions: [],
  allContributions: [],
  uniqueGroupIds: []
}

const actions = {
  getUserData ({commit, state, rootState}) {
    return userAPI.getUser(rootState.user.user.id, [
      'UserBusiness',
      'UserBusiness.Company',
      'UserBusiness.Company.Contributions.Impact',
      'UserBusiness.Company.Contributions.Story.Project',
      'UserBusiness.Company.Contributions.Project',
      'UserBusiness.Company.Contributions.BundleProject',
      'UserBusiness.Company.Contributions.Project.Impacts',
      'UserBusiness.Company.Contributions.Project.ImageSquare',
      'UserBusiness.Company.Contributions.Story.Project.ImageSquare',
      'UserBusiness.Company.Contributions.Project.Categories',
      'Contributions.Impact',
      'Contributions.Story.Project',
      'Contributions.Project',
      'Contributions.BundleProject',
      'Contributions.Project.Impacts',
      'Contributions.Project.ImageSquare',
      'Contributions.Story.Project.ImageSquare',
      'Contributions.Project.Categories',
      'UserBusiness.Company.Contributions.Project.ImageRectangle',
      'UserBusiness.Company.Contributions.Story.Project.ImageRectangle',
      'Contributions.Project.ImageRectangle',
      'Contributions.Story.Project.ImageRectangle'
    ])
  },
  filterChartContributions ({state, commit}, payload) {
    let chartContributions = state.chartContributions.filter(i => {
      if (payload.end && (moment(i.contribution_date) >= moment(payload.end).utc().endOf('day'))) return false
      if (payload.start && (moment(i.contribution_date) <= moment(payload.start).utc().startOf('day'))) return false
      return true
    })
    commit('setChartContributions', chartContributions)
  }
}

const mutations = {
  setData (state, response) {
    return new Promise((resolve) => {
      state.allData = response
      let contributions = response.contributions.reverse()
      if (state.allData.account === 'company') {
        if (response.user_business !== undefined && response.user_business.company !== undefined) {
          contributions = response.user_business.company.contributions.reverse()
        }
      }

      state.contributions = contributions.filter(contribution => contribution.payment_received === 1 && contribution.contribution_date)
      state.chartContributions = state.contributions
      state.allContributions = state.contributions
      resolve(response)
    })
  },
  setChartContributions (state, chartContributions) {
    state.chartContributions = chartContributions
  },
  filterContributions (state, payload) {
    state.contributions = state.contributions.filter(i => {
      if (payload.end && moment(i.contribution_date) >= moment(payload.end).utc().endOf('day')) return false
      if (payload.start && moment(i.contribution_date) <= moment(payload.start).utc().startOf('day')) return false
      return true
    })
  },
  clearChartFilter (state) {
    let chartContributions = state.allData.account === 'company' ? state.allContributions : state.allData.contributions
    state.chartContributions = chartContributions.filter(contribution => contribution.payment_received === 1 && contribution.contribution_date)
  },
  clearFilter (state) {
    let contributions = state.allData.account === 'company' ? state.allContributions : state.allData.contributions
    state.contributions = contributions.filter(contribution => contribution.payment_received === 1 && contribution.contribution_date)
  }
}

const getters = {
  getProfile (state) {
    return state.allData
  },
  getContributions (state) {
    return state.contributions
  },
  getChartContributions (state) {
    return state.chartContributions
  },
  getNoOfGivings (state) {
    return state.chartContributions.length
  },
  getUniqueContributions (state) {
    let uniqueGroupIds = []
    state.chartContributions.forEach(contribution => {
      let groupId = contribution.contribution_group_id
      if (uniqueGroupIds.indexOf(groupId) === -1) {
        uniqueGroupIds.push(groupId)
      }
    })
    return uniqueGroupIds.length
  },
  getTopCategory (state) {
    let sum = []
    state.chartContributions.forEach(contribution => {
      contribution.project.categories.forEach(i => {
        if (sum.filter(item => item.id === i.id).length > 0) {
          sum.filter(p => p.date === i.contribution_date)[0].impact += contribution.quantity * ((contribution.impact != null) ? contribution.impact.impact_unit : 0)
        } else {
          let item = {
            id: i.id,
            name: i.name,
            impact: contribution.quantity * ((contribution.impact != null) ? contribution.impact.impact_unit : 0)
          }
          sum.push(item)
        }
      })
    })
    if (sum.length > 0) {
      return sum.reduce(function (prev, current) {
        return (prev.impact > current.impact) ? prev : current
      })
    } else {
      return []
    }
  },
  getDisplayImpactData (state) {
    return state.allData
  },
  getUserTotalImpact (state) {
    return state.chartContributions.reduce(function (sum, current) {
      return sum + current.beneficiaries
    }, 0)
  },
  getUserTotalAmountGiven (state) {
    return state.chartContributions.reduce((sum, current) => sum + current.amt_total_usd, 0).toFixed(2)
  },
  getDisplayContributionsData (state) {
    let impacts = []
    state.contributions.forEach(i => {
      if (impacts.filter(p => p.date === i.contribution_date).length > 0) {
        if (i.contribution_story_id) {
          // impacts.filter(p => p.date === i.contribution_date)[0].impact += i.story.quantity * ((i.impact != null) ? i.impact.impact_unit : 0) * i.quantity
          impacts.filter(p => p.date === i.contribution_date)[0].impact += i.beneficiaries
        } else {
          // impacts.filter(p => p.date === i.contribution_date)[0].impact += ((i.impact != null) ? i.impact.impact_unit : 0) * i.quantity
          impacts.filter(p => p.date === i.contribution_date)[0].impact += i.beneficiaries
        }
        impacts.filter(p => p.date === i.contribution_date)[0].total_usd += i.amt_total_usd
        impacts.filter(p => p.date === i.contribution_date)[0].total_sgd += i.amt_total_sgd
        impacts.filter(p => p.date === i.contribution_date)[0].impacts.push(i)
      } else {
        let count = i.beneficiaries
        /* let count = ((i.impact != null) ? i.impact.impact_unit : 0) * i.quantity
        if (i.contribution_story_id) {
          count *= i.story.quantity
        } */
        let item = {
          story: i.contribution_story_id,
          date: i.contribution_date,
          impact: count,
          total_usd: i.amt_total_usd,
          total_sgd: i.amt_total_sgd,
          impacts: []
        }
        item.impacts.push(i)
        impacts.push(item)
      }
    })
    return impacts
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userData.js